import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cms-product-management",
  "use": "icon-cms-product-management-usage",
  "viewBox": "0 0 220 220",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 220 220\" id=\"icon-cms-product-management\">\r\n  <path d=\"M110,23.56,35.14,66.78v86.44L110,196.44l74.86-43.22V66.78Zm65.86,78.7-65.86,38-65.86-38V76.72l65.86,38,65.86-38ZM171,69.15l-61,35.2L49,69.15,110,34ZM44.14,112.65,105.39,148v35.38L44.14,148Zm70.25,70.86V148.14l61.47-35.49V148Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol